import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	errorStateHeader: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	errorStateHeaderIssueTermRefresh: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	errorStateDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	noLinkedIssues: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	noLinkedIssuesIssueTermRefresh: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	errorStateHeader: {
		id: 'servicedesk-insight-object-graph.object-view.linked-issues.error-state-header',
		defaultMessage: "We couldn't fetch the linked issues for this object",
		description: 'Header text for when something goes wrong fetching linked issues',
	},
	errorStateHeaderIssueTermRefresh: {
		id: 'servicedesk-insight-object-graph.object-view.linked-issues.error-state-header-issue-term-refresh',
		defaultMessage: "We couldn't fetch the linked work items for this object",
		description: 'Header text for when something goes wrong fetching linked work items',
	},
	errorStateDescription: {
		id: 'servicedesk-insight-object-graph.object-view.linked-issues.error-state-description',
		defaultMessage: 'Try reloading the page.',
		description: 'Description text for when something goes wrong fetching linked issues',
	},
	noLinkedIssues: {
		id: 'servicedesk-insight-object-graph.object-view.linked-issues.no-linked-issues',
		defaultMessage: 'No linked issues',
		description: 'Label for when there are no linked issues for the object',
	},
	noLinkedIssuesIssueTermRefresh: {
		id: 'servicedesk-insight-object-graph.object-view.linked-issues.no-linked-issues-issue-term-refresh',
		defaultMessage: 'No linked work items',
		description: 'Label for when there are no linked work items for the object',
	},
});
export default messages;
